import React from 'react';
import { RydProject } from '../../model/project';
import { RydLoadProjectDialog } from './RydLoadProjectDialog';
import { RydMidiLoadDialog } from './RydMidiLoadDialog';
import { RydCollapsableCard } from '../widgets/RydCollapsableCard';

export function ApplicationMainOptions({
    setProject,
}: {
    setProject: (project: RydProject) => void,
}) {

    return (<>
        <RydCollapsableCard title="Load Project" >
            <RydLoadProjectDialog setProject={setProject} />
        </RydCollapsableCard>
        <RydCollapsableCard title="MIDI import" >
            <RydMidiLoadDialog setProject={setProject} />
        </RydCollapsableCard>
    </>);
}